<tec-modal
    [isVisible]="true"
    [title]="`WORKFLOWS.${modalMode}.TITLE` | translate"
    [tagImage]="{ icon: 'icon-flow', status: 'simple' }"
    (closeEvent)="closeModal()"
>
    <div class="body__text">
        <span>{{ `WORKFLOWS.${modalMode}.DESCRIPTION` | translate }}</span>
    </div>

    <div class="grid" [class]="modalMode === 'CREATE' ? 'grid-e3-sm' : 'grid-e2-sm'">
        <tec-card-access
            [title]="`WORKFLOWS.${modalMode}.ASSISTED_CONFIG_TITLE` | translate"
            [description]="`WORKFLOWS.${modalMode}.ASSISTED_CONFIG_DESCRIPTION` | translate"
            [tagImage]="{ icon: 'icon-AI', status: 'default' }"
            (click)="closeModal('assisted', $event)"
        />
        <tec-card-access
            [title]="`WORKFLOWS.${modalMode}.JSON_EDITOR_TITLE` | translate"
            [description]="`WORKFLOWS.${modalMode}.JSON_EDITOR_DESCRIPTION` | translate"
            [tagImage]="{ icon: 'icon-back-ajax-result', status: 'level' }"
            (click)="closeModal('json')"
        />
        @if (modalMode === 'CREATE') {
            <tec-card-access
                [title]="'WORKFLOWS.CREATE.DEFAULT_TITLE' | translate"
                [description]="'WORKFLOWS.CREATE.DEFAULT_DESCRIPTION' | translate"
                [tagImage]="{ icon: 'icon-copy', status: 'control' }"
                (click)="closeModal('default')"
            />
        }
    </div>
</tec-modal>
